import {
  FC,
  PropsWithChildren,
  Fragment,
  useState,
  useCallback,
  useMemo,
} from "react";
import ReactGA from "react-ga4";
import RequestACallContext from "./RequestACallContext";
import RequestACallbackModal from "./RequestACallbackModal";
import { CALLBACK_REQUEST_INITIATED } from "utills/events";

const RequestACallProvider: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    ReactGA.event(CALLBACK_REQUEST_INITIATED, {});
    setOpen(true);
  }, [setOpen]);

  const handleCloseModal = () => setOpen(false);

  const value = useMemo(() => ({ handleOpen }), [handleOpen]);

  return (
    <Fragment>
      <RequestACallContext.Provider value={value}>
        {children}
      </RequestACallContext.Provider>
      <RequestACallbackModal
        open={open}
        onClose={handleCloseModal}
        handleCloseModal={handleCloseModal}
      />
    </Fragment>
  );
};

export default RequestACallProvider;
